export const GET_RECONCILIATION_OPPORTUNITY_LIST = 'GET_RECONCILIATION_OPPORTUNITY_LIST';

export const PENDDING_RECONCIL_BOOKING_LIST = 'PENDDING_RECONCIL_BOOKING_LIST';

export const SET_RECONCILIATION_OPPORTUNITY_LIST = 'SET_RECONCILIATION_OPPORTUNITY_LIST';

export const GET_RECONCIL_LANDLORD = 'GET_RECONCIL_LANDLORD';

export const GET_RECONCIL_PROPERTIES = 'GET_RECONCIL_PROPERTIES';

export const GET_RECONCIL_COMISSION = 'GET_RECONCIL_COMISSION';

export const GET_RECONCIL_BOOKING_DETAILS = 'GET_RECONCIL_BOOKING_DETAILS';

export const CREATE_OPPORTUNITY_CASE = 'CREATE_OPPORTUNITY_CASE';

export const CHECK_OPPORTUNITY_CASE = 'CHECK_OPPORTUNITY_CASE';

export const UPDATE_RECONCIL_BOOKING_DETAILS = 'UPDATE_RECONCIL_BOOKING_DETAILS';

export const GET_RECONCIL_BOOKING_PENDING_NOTES = 'GET_RECONCIL_BOOKING_PENDING_NOTES';
